import messages from './templates/messages.json'
import patient from './templates/patient.json'
import forms from './templates/forms.json'
import examsProcedures from './templates/examsProcedures.json'
import documentEmission from './templates/documentEmission.json'
import customDocument from './templates/customDocument.json'
import medicalCareHistory from './templates/medicalCareHistory.json'
import historic from './templates/historic.json'
import auth from './templates/auth.json'
import healthProcedures from './templates/healthProcedures.json'
import diagnoses from './templates/diagnoses.json'
import feedback from './templates/feedback.json'
import allergies from './templates/allergies.json'
import laboratory from './templates/laboratory.json'
import maternalInfant from './templates/maternalInfant.json'
import analyticalModels from './templates/analyticalModels.json'
import behaviors from './templates/behaviors.json'
import fetalDiagnoses from './templates/fetalDiagnoses.json'
import titles from './templates/titles.json'
import detailsMedicalEvents from './templates/detailsMedicalEvents.json'
import timeline from './templates/timeline.json'
import historyLaboratoryTests from './templates/historyLaboratoryTests.json'

enum ETemplates {
  messages = 'messages',
  patient = 'patient',
  forms = 'forms',
  documentEmission = 'documentEmission',
  customDocument = 'customDocument',
  medicalCareHistory = 'medicalCareHistory',
  examsProcedures = 'examsProcedures',
  historic = 'historic',
  auth = 'auth',
  healthProcedures = 'healthProcedures',
  diagnoses = 'diagnoses',
  feedback = 'feedback',
  allergies = 'allergies',
  laboratory = 'laboratory',
  maternalInfant = 'maternalInfant',
  analyticalModels = 'analyticalModels',
  behaviors = 'behaviors',
  fetalDiagnoses = 'fetalDiagnoses',
  titles = 'titles',
  detailsMedicalEvents = 'detailsMedicalEvents',
  timeline = 'timeline',
  historyLaboratoryTests = 'historyLaboratoryTests'
}

const templates = {
  messages,
  patient,
  forms,
  documentEmission,
  customDocument,
  medicalCareHistory,
  examsProcedures,
  historic,
  auth,
  healthProcedures,
  diagnoses,
  feedback,
  allergies,
  laboratory,
  maternalInfant,
  analyticalModels,
  behaviors,
  fetalDiagnoses,
  titles,
  detailsMedicalEvents,
  timeline,
  historyLaboratoryTests
}

export type IFunctionMessage = (value: string) => string

/**
 *
 * @param {string} value value to pass, it is the path of the text in the json file
 * @returns {string} return the string matched with the path passed
 */
export const message: IFunctionMessage = (value: string): string => {
  const firstPath = value.split('.').shift() ?? ''

  if (!ETemplates[firstPath]) return ''

  const secondPath = value.split('.').pop() ?? ''

  return templates[firstPath][secondPath] ?? ''
}
